import {
  BodyLG,
  BodyLGB,
  BodyMD,
  BodyXL,
  Heading2XL,
  Heading5XL,
} from "../../../typography";

import { Link } from "react-router-dom";

export const Hero = () => (
  <div className="tw-flex tw-flex-col tw-items-center tw-gap-y-[2em]">
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-y-[1.25em]">
      {/* Desktop version */}
      <Heading5XL
        className="tw-m-auto tw-hidden tw-w-full tw-justify-center tw-text-center tw-text-white min840:tw-flex"
        dataTestId="home-page-header"
      >
        AI-enabled ordering for
      </Heading5XL>
      <Heading5XL className="tw-m-auto tw-hidden tw-w-full tw-text-center tw-text-white min840:tw-flex">
        medical equipment & supplies
      </Heading5XL>
      <BodyXL className="tw-my-0 tw-hidden tw-max-w-[574px] tw-text-center tw-text-white min840:tw-flex">
        Take the pain & confusion out of ordering Durable Medical Equipment
        (DME) for patients.
      </BodyXL>

      {/* Mobile version */}
      <Heading2XL
        className="tw-m-auto tw-flex tw-w-full tw-text-center tw-text-white min840:tw-hidden"
        dataTestId="home-page-header-mobile"
      >
        AI-enabled ordering for medical equipment & supplies.
      </Heading2XL>
      <BodyLG className="tw-my-0 tw-max-w-[574px] tw-text-center tw-text-white min840:tw-hidden">
        Take the pain & confusion out of ordering Durable Medical Equipment
        (DME) for patients.
      </BodyLG>
    </div>
    <div className="tw-flex tw-flex-row tw-justify-center">
      <Link
        to="/contact"
        className="tw-z-40 tw-rounded-full tw-bg-blue-2 tw-p-[1em] tw-px-[4em] tw-text-white tw-shadow-sm hover:tw-bg-blue-0 hover:tw-text-white hover:tw-no-underline focus:tw-text-white focus:tw-no-underline"
      >
        <BodyLGB className="tw-mb-0 tw-hidden tw-text-white min840:tw-flex">
          Get a demo
        </BodyLGB>
        <BodyMD className="tw-mb-0 tw-text-white min840:tw-hidden">
          Get a demo
        </BodyMD>
      </Link>
    </div>
  </div>
);
